import Request from "@/common/net/request.js";
const request = new Request();
// 所有字典
export function getAllConfig() {
  return request.send({
    url: `/pmy/sys/dict-data/all`,
    method: "get"
  });
}
// 获取所偶菜单树
export function getMenuTree(data) {
  return request.send({
    url: `/joker/menu/tree`,
    method: "get"
  });
}
// 获取地域数据
export function getAreaTree(data) {
  return request.send({
    url: `/pmy/sys/area/tree`,
    method: "get"
  });
}
// 根据areaCode获取下一级
export function getAreaNext(data) {
  return request.send({
    url: `/pmy/sys/area/next`,
    method: "get",
    data
  });
}

// 统一文件上传
export function uploadFile(data) {
  return request.send({
    url: `/pmy/file/sys-file/upload`,
    method: "post",
    data,
    config: {
      isEncrypted: true,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  });
}

// 获取微信支付链接（用于生成微信支付二维码）
export function getWxPayQr(data) {
  return request.send({
    url: `/pmy/freight/order/freight/wechat/pay/url`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 查询支付详情
export function getWxPayStatus(orderId) {
  return request.send({
    url: `/pmy/freight/order/freight/payment/info/byOrder?orderId=${orderId}`,
    method: "get"
  });
}

// 统一文件下载
export function downloadFile(fileId) {
  return request.send({
    url: `/pmy/file/sys-file/download?fileId=${fileId}`,
    method: "get",
    config: {
      isEncrypted: true,
      responseType: "blob"
    }
  });
}
// 统一文件下载
export function downloadFilePublic(fileId, credit) {
  return request.send({
    url: `/file/sys-file/download/public?fileId=${fileId}&credit=${credit}`,
    method: "get",
    config: {
      isEncrypted: true,
      responseType: "blob"
    }
  });
}

// 统一文件下载(获取令牌)
export function getShortToken() {
  return request.send({
    url: `/file/sys-file/short/token`,
    method: "get"
  });
}
// 获取字典列表
export function getDictPage(type) {
  return request.send({
    url: `/joker/dict-data/list?dictType=${type}`,
    method: "get"
  });
}

// 获取所有字典数据
export function getDictPageAll(type) {
  return request.send({
    url: `/joker/dict-data/all`,
    method: "get"
  });
}

// 根据身份证照片获取用户信息
export function getUserInfo(data) {
  return request.send({
    url: `/joker/ocr/id_card`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 无痛刷新
export function refreshToken(data) {
  return request.send({
    url: `/joker/sys/refresh_token`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 获取组织树
export function getAllTree() {
  return request.send({
    url: `/pmy/sys/dept/tree`,
    method: "get"
  });
}
// 添加组织
export function addDept(data) {
  return request.send({
    url: `/pmy/sys/dept`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 编辑组织
export function editDept(data) {
  return request.send({
    url: `/pmy/sys/dept`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 删除组织
export function deleteDept(deptId) {
  return request.send({
    url: `/pmy/sys/dept?deptId=${deptId}`,
    method: "delete"
  });
}

// 获取调度组下的调度人员
export function getDispatchers(deptId) {
  return request.send({
    url: `/pmy/sys/user/dispatchers${deptId ? "deptId=" + deptId : ""}`,
    method: "get"
  });
}

// 获取公司下车队长
export function getCheDuiZhang(companyId) {
  return request.send({
    url: `/pmy/sys/user/vehicle-leaders?companyId=${companyId}`,
    method: "get"
  });
}

// 获取调度组部门列表
export function getDispatchDept(companyId) {
  return request.send({
    url: `/pmy/sys/dept/dispatch`,
    method: "get"
  });
}

// 获取调度组下的调度人员
export function getDispatchDeptForUser(deptId) {
  return request.send({
    url: `/pmy/sys/user/dispatchers?deptId=${deptId ? deptId : ""}`,
    method: "get"
  });
}
// 司机派单--查询我的调度司机列表
export function getDispatchDriver(data) {
  return request.send({
    url: `/pmy/sys/driver/dispatch/mine`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 司机派单--查询临调司机列表
export function getLinDiaoDriver(data) {
  return request.send({
    url: `/pmy/sys/driver/dispatch/temp`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// WEB端--平台司机充值
export function platformRecharge(data) {
  return request.send({
    url: `/pmy/sys/wallet/web/recharge/user`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// WEB端--装卸点跳过
export function freightSkip(data) {
  return request.send({
    url: `/pmy/freight/order/freight/skip`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 预生成一个订单ID
export function setFreightId() {
  return request.send({
    url: `/pmy/freight/order/freight/id`,
    method: "get"
  });
}

// 获取用户信息
export function getUserData() {
  return request.send({
    url: `/pmy/sys/user/me`,
    method: "get"
  });
}

// （WEB端）获取司机今日上报位置
export function getTodayReport(driverId) {
  return request.send({
    url: `/pmy/sys/driver/report/today?driverId=${driverId}`,
    method: "get"
  });
}

// （WEB端）查询司机最近运输中订单的装货位置
export function getLastedPointReport(driverId) {
  return request.send({
    url: `/pmy/freight/order/freight/driver/lasted-point?driverId=${driverId}`,
    method: "get"
  });
}
